import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getCityList, saveCity } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class generalCities extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              arealist: [],
              openedAdd:false
        };

        this.getCityList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  


    saveCity = ()=>{
        
        let req = JSON.stringify({
            city:this.state.city,
            latitude:this.state.latitude,  
            longtitude:this.state.longtitude
        })

        saveCity(req).then((response) => {
          
          if(response.status==1){

                alert("success");
                this.getCityList();

          }else{
                alert("error");
          }
      
        });
     

    }

    getCityList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getCityList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            arealist: res.list
            
          });
        } else {
          this.setState({
            arealist: [],
          });
        }
      });
    }    

    render() {

        const { arealist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">City</h4>
                 
 
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&
                    <form>
                     <div class="row col-lg-12">
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                          <label>City name</label>
                          <input type="text" class="form-control" name="city" onChange={this.handleChange} />

                        </div>

                        <div class="form-row">
                          
                          <label>Latitude</label>

                          <input type="text" class="form-control" name="latitude" onChange={this.handleChange} />

                        </div>

                        <div class="form-row">
                          
                          <label>Longtitude</label>

                          <input type="text" class="form-control" name="longtitude" onChange={this.handleChange} />

                        </div>
                       <div class="form-group row">
                          <div class="col-sm-10">
                            <button type="button" onClick={this.saveCity} class="btn btn-primary">Save</button>
                          </div>
                        </div>
                         
                      </div>

                     </div>

                     
                    </form>
                  }
                  
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th >
                            <strong>S.No</strong>
                          </th>
                          <th >
                            <strong>City</strong>
                          </th>
                     
                          <th>
                            <strong>Latitude</strong>
                          </th>

                          <th >
                            <strong>Longtitude</strong>
                          </th>

                          <th >
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {arealist.map((item, i) => {     
                      
                       return <tr>
                          <td  >
                            {i+1}
                          </td>
                                                  
                        
                          <td  >
                            {item.city}
                          </td>
                         
                          <td  >
                            {item.latitude}
                          </td>
                         
                          <td  >
                            {item.longtitude}
                          </td>
                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                             

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default generalCities;


// WEBPACK FOOTER //
// ./src/components/bewise/generalCities.jsx